import React from "react";
import Input from "./forms/Input";
import Select from "./forms/Select";

const Ingredient = ({ ingredient, onChange, isSaving, errors }) => {
  const units = ['', 'tsp', 'tbsp', 'cups', 'pt', 'qt', 'gal', 'ml', 'l', 'g', 'kg', 'fl oz', 'oz', 'lb']

  return (
    <>
      <Input 
        value={ingredient.quantity} 
        type="text" 
        onChange={(value) => onChange("quantity", value)} 
        placeholder="1 1/2" 
        className="w-16" 
        error={errors?.quantity} 
        showError={false}
        disabled={isSaving}
      />
      <Select 
        options={units} 
        value={ingredient.units} 
        onChange={(value) => onChange("units", value)}  
        className="w-20" 
        error={errors?.units} 
        showError={false}
        disabled={isSaving}
      />
      <Input 
        value={ingredient.name} 
        type="text" 
        onChange={(value) => onChange("name", value)} 
        placeholder="flour" 
        className="w-54" 
        error={errors?.name} 
        showError={false}
        disabled={isSaving}
      />
      <div>
        <label name="optional" className="mr-2">Optional?</label>
        <input type="checkbox" checked={!!ingredient.optional} onChange={(e) => onChange("optional", e.target.checked)} disabled={isSaving} />
      </div>
    </>
  )
}

export default Ingredient;